import React from "react";
import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";

import nikeLogo from "../assets/Logo_NIKE.svg";
import persoLogo from "../assets/persostack_logo.png";
import { useCartContext } from "../context/CartContext";
import { links } from "../utils/constants";
import CartButton from "./CartButton";
import SearchButton from "./SearchButton";

const Navbar = () => {
  const { itemCount } = useCartContext();
  return (
    <NavContainer>
      <div className="nav-center">
        <div className="nav-header">
          <Link to="/">
            <img src={persoLogo} alt="logo-persostack" />
          </Link>
          <Link to="/">
            <img src={nikeLogo} alt="logo-nike" />
          </Link>
        </div>
        <ul className="nav-links">
          {links.map((link) => {
            const { id, text, url } = link;
            return (
              <li key={id}>
                <NavLink exact activeClassName="selected" to={url}>
                  {text}
                </NavLink>
              </li>
            );
          })}
        </ul>
        <div className={"nav-btns"}>
          <SearchButton className={"search"} />
          <CartButton itemCount={itemCount} />
        </div>
      </div>
    </NavContainer>
  );
};

const NavContainer = styled.nav`
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  box-shadow: 2px 2px 16px 0 rgba(0, 0, 0, 0.14);

  .nav-center {
    width: 90vw;
    margin: 0 auto;
    max-width: var(--max-width);
  }
  .nav-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 58px;
      margin-right: 10px;
    }
  }
  .nav-toggle {
    background: transparent;
    border: transparent;
    color: var(--clr-primary-5);
    cursor: pointer;
    svg {
      font-size: 2rem;
    }
  }
  .nav-links {
    display: none;
  }
  .nav-btns {
    display: flex;
  }
  .search {
    margin-right: 1rem;
  }
  @media (min-width: 992px) {
    .nav-toggle {
      display: none;
    }
    .nav-center {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
    }
    .nav-links {
      display: flex;
      transition: all 0.5s ease;
      font-family: HelveticaNeue-Bold;
      list-style-type: none;
      margin: 0 0 0 60px;
      padding: 0;
      li {
        margin: 0 55px 0 0;
        font-family: HelveticaNeue-Bold;
        font-size: 20px;
        color: #848991;
        .selected {
          color: #404c5d;
        }
      }
      a {
        color: var(--clr-grey-3);
        text-decoration: none;
        letter-spacing: var(--spacing);
        &:hover {
          border-bottom: 2px solid var(--clr-primary-1);
          color: #404c5d;
        }
      }
    }
    .cart-btn-wrapper {
      display: grid;
    }
  }
`;

export default Navbar;
